__turbopack_context__.v({
  "app_light_theme": "discount-list-module-scss-module__B5SlFW__app_light_theme",
  "inner": "discount-list-module-scss-module__B5SlFW__inner",
  "inner__open": "discount-list-module-scss-module__B5SlFW__inner__open",
  "item": "discount-list-module-scss-module__B5SlFW__item",
  "list": "discount-list-module-scss-module__B5SlFW__list",
  "topPanel": "discount-list-module-scss-module__B5SlFW__topPanel",
});
